import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

const AUTH_URL = '/oauth';
const API_URL = '/api';

export class BaseApiService {

  protected options: any = {
    headers: new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    })
  };

  protected mode = 'runner';
  protected oauthClientSecret = '';

  constructor(
    protected http: HttpClient
  ) {
    this.oauthClientSecret = environment.oauthClientSecret;
  }

  public getSysinfo(): Observable<any> {
    const url = environment.baseUrl.replace(/\/$/, '') + API_URL + '/' + 'sysinfo';
    return this.http.get<any>(url, this.options).pipe(
      catchError(err => {
        return throwError(this.buildError(err));
      })
    );

  }

  protected getUrl(url: string): string {
    return environment.baseUrl.replace(/\/$/, '') + API_URL + '/' + this.mode + '/' + url;
  }

  protected getAuthUrl(url: string): string {
    return environment.baseUrl.replace(/\/$/, '') + AUTH_URL + '/' + url;
  }

  protected buildError(error: any): any {
    return {
      status: error.status,
      message: (error.status === 500) ? 'Technischer Fehler' : error.error.message,
      fielderrors: error.error.fielderrors
    };
  }

}
